"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_scss_1 = __importDefault(require("./styles.scss"));
const jsStyles = {
    cardStyle: {
        style: {
            base: {
                color: styles_scss_1.default.black,
                fontSize: styles_scss_1.default.mFont,
                '::placeholder': {
                    color: styles_scss_1.default.darkGrey,
                },
                border: `2px solid ${styles_scss_1.default.primary}`,
                padding: '11.4px 12px',
            },
            invalid: {
                color: styles_scss_1.default.warning,
                iconColor: styles_scss_1.default.warning,
            },
        },
    },
};
exports.default = jsStyles;
